import { Link } from 'react-router-dom';

export const NotFound = () => (
  <div className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center px-6">
    <div className="max-w-md text-center">
      <p className="font-mono text-[11px] tracking-widest uppercase text-gold mb-6">Error 404</p>
      <h1 className="font-display text-4xl font-light mb-4">Esta página no existe.</h1>
      <p className="font-sans text-sm text-white/60 leading-relaxed mb-10">
        Puede que el enlace esté mal escrito o que la página haya cambiado de sitio.
      </p>
      <Link
        to="/"
        className="font-mono text-[11px] tracking-widest uppercase text-gold hover:text-white transition-colors"
      >
        ← Volver al inicio
      </Link>
    </div>
  </div>
);
